<template>
    <button  class="button " @touchstart="startTimer" @touchend="endTimer" :onmousedown="startTimer" :onmouseup="endTimer" @click="toggleState" @contextmenu="handleContextMenu($event)" :class="{important: important, success: success, failed: failed}" >
        <div class="text-container">
            <p v-if="!success && !failed" class="promt-text">{{prompt}}</p>
            <p v-if="success" class="done-text">Nailed it! </p>
            <p v-if="failed" class="done-text">Failed it! </p>
            <strong v-if="(!success && !failed) || important"><font-awesome-icon :icon="icon" /></strong>
            <div v-if="success" class="animator win"/>
            <div v-if="failed" class="animator lose"/>
            <strong v-if="success" class="rotate-scale-up icon"><font-awesome-icon icon="smile" class="smile" /></strong>
            <strong v-if="failed" class="rotate-scale-up icon"><font-awesome-icon icon="face-frown" class="smile" /></strong>
        </div>
    </button>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
    name: "GameButton",
    components:{
        'font-awesome-icon':FontAwesomeIcon
    },

    data(){
        return{
            success: false,
            failed: false,
            holdingShift: false,
            holding: false
        }
    },
    created(){
      if(this.completed){
        let result = localStorage.getItem(this.index.toString())
        switch(result){
          case '1':
            this.success=true;
            break;
          case '2':
            this.failed=true;
            break;
          default:
            break;
        }
      }
    },

    props:{
        prompt: String,
        index: Number,
        disabled: {
          type:Boolean,
          default: false
        },
        completed:Boolean,
        buttonStyle: Object,
        icon:{
            type: String,
            default: 'exclamation'
            },
        important: {
            type: Boolean,
            default: false
            }
    },
    methods:{
        toggleState(){
            if(this.success || this.failed) return;
            if(this.holdingShift) this.toggleFailed();
            else this.toggleSuccess();
        },
         startTimer(){
            this.holding=true;
            setTimeout(()=> {
                if(this.holding && !this.success) this.toggleFailed()
            }, 500) 
        },
        endTimer(){
            this.holding=false;
            if(!this.failed)this.toggleSuccess();

        },
        toggleSuccess(){
          if(this.disabled) return;
            this.success=true;
            localStorage.setItem(this.index.toString(), '1')
        },
        toggleFailed(){
          if(this.disabled) return;
          if(this.important) return this.toggleSuccess();
            this.failed=true;
            localStorage.setItem(this.index.toString(), '2')
        },
        

        reset(){
                                 this.success=false;
                    this.failed=false;
                    localStorage.setItem(this.index.toString(), '0')

        },
        handleContextMenu(e){
           e.preventDefault();
        }
    }
}
</script>

<style scoped>

.button {
  height: 100%;
  width: 85%;
  max-width: 1000px;
  min-height: 100px;
  max-height: 200px;
    overflow: hidden;
  border-radius: 15px;
  border-width: 0px;
    position:relative;
    padding:8px;
  font: inherit;
  font-size: 0.9em;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.836);
background-color:rgb(230, 230, 230);
}


.animator {

    position: absolute;
    border-radius: 100%;
    animation: scale-in 0.5s linear ;
}

.lose {
    background: rgb(192, 6, 6);
}

.win {
    background-color: rgb(6, 192, 31);

}

.button:hover {
  cursor: pointer;
}


.important {
  color: white;
  background-color: black;
    border-color: rgb(19, 19, 19);

}

.text-container {
    justify-content: center;
    align-items: center;
    display: flex;
    flex:1;

}

.text-container > strong {
    flex: 1;
    flex-shrink: 1;
    padding: 0 10px 0 10px;
    font-size: 2.25em;

}

.text-container > p {
    flex:10;
}



.button:active {
    transform: translate(2px, 2px);
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.877);
}



.smile {
    font-size: 30pt;
}

.success {
        color: white;

    background-color: rgb(6, 192, 31);
    animation: wait 0.5s linear ;
}

.failed {
        color: white;

    background-color: rgb(192, 6, 6);
    animation: wait 0.5s linear ;
}

.done-text {
animation: fade 0.5s linear ;
font-family: 'gomarice_rockin_record';
font-size: 2em;
margin: -5px;
}




.rotate-scale-up {
	animation: rotate-scale-up 0.5s linear ;
}

/* ----------------------------------------------
 * Generated by Animista on 2022-5-12 15:27:5
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation rotate-scale-up
 * ----------------------------------------
 */
@keyframes rotate-scale-up {
  0% {
      opacity: 0;
    transform: scale(1) rotateZ(0);
  }
  50% {
            opacity: 0;
    transform: scale(2) rotateZ(180deg);
  }
  80% {
            opacity: 1;

  }
  100% {
      
    transform: scale(1) rotateZ(360deg);
  }
}

@keyframes wait {
  0%,50% {
      background-color:rgb(230, 230, 230);
  }
  60% {

    background-color: rgb(192, 149, 6);
  }
}



@keyframes fade {
  0%,50% {
      opacity:0;
  }
  60% {
    opacity:1;
  }
}

@keyframes scale-in {
      0% {
    height: 0%;
    width: 0%;
  }
  40% {
    height:200%;
    width: 40%
  }
  60% {
      height:250%;
    width:100%;
    opacity:1;
  }
  80% {
       height:300%;
    width:300%;
    
  }
  100%{
      opacity: 0;
  }
}

</style>